import gql from 'graphql-tag'

export const DOCTOR_LOGIN = gql`
  mutation DOCTOR_LOGIN($email: String!, $password: String!) {
    doctorLogin(email: $email, password: $password) {
      token
    }
  }
`
